export default "__VITE_ASSET__Din0$bPo__"